


































































import { GuildsApi } from '@/services/api/api.guilds';
import { GuildEventLogTypes, GuildEventLogViewObject, GuildViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GuildEventLog extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    @Prop({ required: true, type: Object })
    guild!: GuildViewObject;

    logs: GuildEventLogViewObject[] = [];
    loading: boolean = false;

    GetRankName(rankId: number) {
        const rank = this.guild.ranks.find(x => x.id === rankId);
        return rank ? rank.rankName : 'Unknown rank';
    }

    get logTypes() {
        return {
            INVITE_PLAYER: GuildEventLogTypes.GUILD_EVENT_LOG_INVITE_PLAYER,
            JOIN_GUILD: GuildEventLogTypes.GUILD_EVENT_LOG_JOIN_GUILD,
            PROMOTE_PLAYER: GuildEventLogTypes.GUILD_EVENT_LOG_PROMOTE_PLAYER,
            DEMOTE_PLAYER: GuildEventLogTypes.GUILD_EVENT_LOG_DEMOTE_PLAYER,
            UNINVITE_PLAYER: GuildEventLogTypes.GUILD_EVENT_LOG_UNINVITE_PLAYER,
            LEAVE_GUILD: GuildEventLogTypes.GUILD_EVENT_LOG_LEAVE_GUILD
        };
    }

    logTypesArray = [
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_INVITE_PLAYER, name: 'Invited' },
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_JOIN_GUILD, name: 'Joined' },
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_PROMOTE_PLAYER, name: 'Promoted' },
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_DEMOTE_PLAYER, name: 'Demoted' },
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_UNINVITE_PLAYER, name: 'Uninvited' },
        { id: GuildEventLogTypes.GUILD_EVENT_LOG_LEAVE_GUILD, name: 'Left Guild' }
    ];

    async getGuildEventLogs() {
        this.loading = true;

        try {
            const result = await GuildsApi.GetGuildEventLogs(this.realmId, this.guild.id);
            this.logs = result.logs;
        } finally {
            this.loading = false;
        }
    }

    created() {
        this.getGuildEventLogs();
    }
}
